import { createFileRoute } from '@tanstack/react-router';

import { AboutPageContent } from '~/components/about/AboutPageContent';
import { DEFAULT_LOCALE } from '~/utils/i18n';

const AboutPage = () => {
  return <AboutPageContent />;
};

export const Route = createFileRoute('/about')({
  beforeLoad: ({ context }) => ({
    ...context,
    locale: DEFAULT_LOCALE,
  }),
  component: AboutPage,
});
